import React from "react";

// Types
interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const PrimaryCard: React.FC<CardProps> = ({ children, className = "" }) => (
  <div className={`bg-white rounded-lg  p-4 ${className}`}>{children}</div>
);
export default PrimaryCard;
